class ApiError extends Error {
  constructor(status, message, data = null) {
    super(message);
    this.name = "ApiError";
    this.status = status;
    this.data = data;
  }
}

export const handleError = (error) => {
  // Errore con risposta dal server (4xx, 5xx)
  if (error.response) {
    console.error("Errore nella richiesta:", error.response.data);
    // Ritorna l'errore in formato consistente
    throw new ApiError(
      error.response.status,
      error.response.data.error ||
        error.response.data.message ||
        "Errore del server",
      error.response.data,
    );
  }
  // Errore di rete (nessuna risposta - CORS, timeout, server offline)
  else if (error.request) {
    console.error("Nessuna risposta ricevuta:", error.request);
    throw new ApiError(
      0,
      "Impossibile contattare il server. Verifica che il backend sia in esecuzione su localhost:3001",
      null,
    );
  }
  // Errore nella configurazione della richiesta
  else {
    console.error(
      "Errore durante la configurazione della richiesta:",
      error.message,
    );
    throw new ApiError(-1, error.message || "Errore imprevisto", null);
  }
};
